import {
  Box,
  Text,
  Input,
  Button,
  Flex,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb
} from "@chakra-ui/react";
import {
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import { useSurvey } from "./BusinessSurveyContext";
import { useEffect } from "react";
import { useState } from "react";
export default function BusinessSurveyLoanInfo() {
  const navigate = useNavigate();
  const { surveyData, updateSurveyData } = useSurvey();
  const { loanAmount, monthlySales, monthlyExpenses } = surveyData || {};
  const [salesMonthly, setSalesMonthly] = useState(
  Number.isFinite(monthlySales) ? monthlySales : -1
  );
  const [expensesMonthly, setExpensesMonthly] = useState(
    Number.isFinite(monthlyExpenses) ? monthlyExpenses : -1
  );
  useEffect(() => {
    if (Number.isFinite(monthlySales)) setSalesMonthly(monthlySales);
    if (Number.isFinite(monthlyExpenses)) setExpensesMonthly(monthlyExpenses);
  }, [monthlySales, monthlyExpenses]);

  const uiVal = (v) => (v < 0 ? 0 : v);
  const money = (v) => (v < 0 ? "Not set" : `D${v.toLocaleString()}`);



  return (
    <Box minHeight="100vh" display="flex" flexDirection="column" bg="white">
      <Navbar />
      {/* Header */}
      <Box
        bg="#00C49A"
        height="80px"
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
        pb={2}
      >
        <Text fontSize="lg" fontWeight="bold" color="black">
          RESOURCES
        </Text>
      </Box>
      {/* Main Content */}
      <Box
        flex="1"
        overflowY={["auto", "auto", "visible"]}
        px={4}
        pt={6}
        pb={["140px", "160px"]}
        display="flex"
        justifyContent="center"
        minHeight={{ base: "auto", md: "calc(100vh - 200px)" }}
      >
        <Box width="100%" maxW="480px">
          {/* Title */}
          <Text fontWeight="bold" fontSize="xl" mb={1} textAlign={"center"}>
            Pilot Small Business Assistance Application Survey
          </Text>
          {/* Progress Bar */}
          <Box
            width="100%"
            maxW={{ base: "360px", md: "440px" }}
            mx="auto"
            mb={10}
            height="32px"
            border="2px solid black"
            borderRadius="full"
            overflow="hidden"
          >
            <Box
              width="64%"
              height="100%"
              bg="#00C49A"
              borderRightRadius="full"
            />
          </Box>
          {/* Form Fields */}
          <Box mb={12}>
          <Box mb={8}>
            <Text fontWeight="bold" fontSize="md" mb={2}>
              Average Monthly Sales: {money(salesMonthly)}
            </Text>
            <Slider
              aria-label="slider"
              min={0}
              max={500000}
              step={1000}
              value={uiVal(salesMonthly)}
              onChange={(val) => {
                setSalesMonthly(val);
                updateSurveyData({ monthlySales: val });
              }}
            >
              <SliderTrack bg="#E0E0E0">
                <SliderFilledTrack bg="#00C49A" />
              </SliderTrack>
              <SliderThumb bg="#00C49A" />
            </Slider>
          </Box>

            <Box mb={8}>
              <Text fontWeight="bold" fontSize="md" mb={2}>
                Average Monthly Expenses: {money(expensesMonthly)}
              </Text>
              <Slider
                aria-label="slider"
                min={0}
                max={500000}
                step={1000}
                value={uiVal(expensesMonthly)}
                onChange={(val) => {
                  setExpensesMonthly(val);
                  updateSurveyData({ monthlyExpenses: val });
                }}
              >
                <SliderTrack bg="#E0E0E0">
                  <SliderFilledTrack bg="#00C49A" />
                </SliderTrack>
                <SliderThumb bg="#00C49A" />
              </Slider>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* Back/Next Buttons */}
      <Box
        position="absolute"
        bottom={["110px", "120px"]}
        width="100%"
        bg="white"
        py={3}
        px={6}
        display="flex"
        justifyContent="space-between"
        zIndex={10}
      >
        <Button
          variant="ghost"
          leftIcon={<FaArrowLeft color="#00C49A" />}
          color="black"
          onClick={() => navigate("/business-app-3")}
        >
          Back
        </Button>
        <Button
          variant="ghost"
          onClick={() => {
            if (salesMonthly < 0) {
              alert("Please set your Average Monthly Sales.");
              return;
            }
            if (expensesMonthly < 0) {
              alert("Please set your Average Monthly Expenses.");
              return;
            }
            navigate("/business-app-5")
          }}
          rightIcon={<FaArrowRight color="#00C49A" />}
          color="black"
        >
          Next
        </Button>
      </Box>
      {/* Bottom Navigation */}
      <Flex
        position="fixed"
        bottom={0}
        width="100%"
        bg="white"
        py={3}
        justifyContent="space-around"
        borderTop="2px solid black"
        zIndex={5}
      ></Flex>
    </Box>
  );
}
